// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Nav from "./Nav.re.mjs";
import * as ReactRouterDom from "react-router-dom";
import * as JsxRuntime from "react/jsx-runtime";
import PhotoToOilPainting2xPng from "../global/images/photo-to-oil-painting@2x.png";

import { css, cx } from '@linaria/core'
;

let logo = PhotoToOilPainting2xPng;

let style = (css`

    border-color: rgba(127, 127, 127, 0.3);
    @apply border-t py-3 mt-3;
    &> div {
      @apply sm:grid sm:grid-cols-2 md:grid-cols-3 gap-4 text-xs leading-5;
      h3 {
        @apply text-xl mb-2;
      }
      ul {
        @apply list-none;
      }

    }
    `);

let Root = {
  style: style
};

function Footer(props) {
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsxs(Nav.LayoutContainer.make, {
      children: [
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("h3", {
              children: "Explore"
            }),
            JsxRuntime.jsxs("ul", {
              children: [
                JsxRuntime.jsx("li", {
                  children: JsxRuntime.jsx(ReactRouterDom.Link, {
                    to: "/gallery/featured/paintings",
                    children: "Oil Painting Gallery",
                    reloadDocument: true
                  })
                }),
                JsxRuntime.jsx("li", {
                  children: JsxRuntime.jsx(ReactRouterDom.Link, {
                    to: "/assets",
                    children: "AI Instant Preview"
                  })
                }),
                JsxRuntime.jsx("li", {
                  children: JsxRuntime.jsx(ReactRouterDom.Link, {
                    to: "/pet-portraits",
                    children: "Pet Portraits"
                  })
                }),
                JsxRuntime.jsx("li", {
                  children: JsxRuntime.jsx(ReactRouterDom.Link, {
                    to: "/portrait-paintings",
                    children: "Portrait Paintings"
                  })
                }),
                JsxRuntime.jsx("li", {
                  children: JsxRuntime.jsx(ReactRouterDom.Link, {
                    to: "/baby-paintings",
                    children: "Baby & Kids Paintings"
                  })
                }),
                JsxRuntime.jsx("li", {
                  children: JsxRuntime.jsx(ReactRouterDom.Link, {
                    to: "/wedding-paintings",
                    children: "Wedding Paintings"
                  })
                }),
                JsxRuntime.jsx("li", {
                  children: JsxRuntime.jsx(ReactRouterDom.Link, {
                    to: "/landscape-paintings",
                    children: "Landscape & Other Paintings"
                  })
                }),
                JsxRuntime.jsx("li", {
                  children: JsxRuntime.jsx(ReactRouterDom.Link, {
                    to: "/dog-paintings",
                    children: "Dog Paintings"
                  })
                }),
                JsxRuntime.jsx("li", {
                  children: JsxRuntime.jsx(ReactRouterDom.Link, {
                    to: "/cat-paintings",
                    children: "Cat Paintings"
                  })
                }),
                JsxRuntime.jsx("li", {
                  children: JsxRuntime.jsx(ReactRouterDom.Link, {
                    to: "/horse-paintings",
                    children: "Horse Paintings"
                  })
                }),
                JsxRuntime.jsx("li", {
                  children: JsxRuntime.jsx(ReactRouterDom.Link, {
                    to: "/bird-paintings",
                    children: "Bird Paintings"
                  })
                }),
                JsxRuntime.jsx("li", {
                  children: JsxRuntime.jsx("a", {
                    children: "Join as an Artist",
                    href: "/artists/signup"
                  })
                })
              ]
            })
          ]
        }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("h3", {
              children: "About Us"
            }),
            JsxRuntime.jsxs("ul", {
              children: [
                JsxRuntime.jsx("li", {
                  children: JsxRuntime.jsx("a", {
                    children: "Our Company",
                    href: "/about",
                    target: "_self"
                  })
                }),
                JsxRuntime.jsx("li", {
                  children: JsxRuntime.jsx("a", {
                    children: "Privacy Policy",
                    href: "/privacy",
                    target: "_self"
                  })
                }),
                JsxRuntime.jsx("li", {
                  children: JsxRuntime.jsx("a", {
                    children: "Terms of Service",
                    href: "/tos",
                    target: "_self"
                  })
                }),
                JsxRuntime.jsx("li", {
                  children: JsxRuntime.jsx("a", {
                    children: "Refund Policy",
                    href: "/refunds",
                    target: "_self"
                  })
                }),
                JsxRuntime.jsx("li", {
                  children: JsxRuntime.jsx("a", {
                    children: "Art & Tech Blog",
                    href: "/blog",
                    target: "_self"
                  })
                })
              ]
            })
          ]
        }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("h3", {
              children: "Contact Us"
            }),
            JsxRuntime.jsxs("p", {
              children: [
                "General Questions: ",
                JsxRuntime.jsx("a", {
                  children: "support@instapainting.com",
                  href: "mailto:support@instapainting.com"
                }),
                JsxRuntime.jsx("br", {}),
                JsxRuntime.jsx("a", {
                  children: "Existing Customers",
                  href: "/support"
                }),
                JsxRuntime.jsx("br", {}),
                JsxRuntime.jsx("br", {}),
                "Born in San Francisco."
              ]
            }),
            JsxRuntime.jsx("a", {
              children: "Follow @instapainting",
              href: "https://twitter.com/instapainting"
            })
          ]
        })
      ]
    }),
    className: style
  });
}

let make = Footer;

let $$default = Footer;

export {
  logo,
  Root,
  make,
  $$default as default,
}
/*  Not a pure module */
